import { render, staticRenderFns } from "./SideBarMenuGroup.vue?vue&type=template&id=41245e72&scoped=true&"
import script from "./SideBarMenuGroup.vue?vue&type=script&lang=js&"
export * from "./SideBarMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./SideBarMenuGroup.vue?vue&type=style&index=0&id=41245e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41245e72",
  null
  
)

export default component.exports